import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../Components/PrimeReact/logo";
import DisclosureScroller from "../../Components/TextScroller/disclosureScoller";
import StockScroller from "../../Components/TextScroller/stockScroller";
import { DateTimer } from "../../Components/Timer/dateTimer";
import {
  retrieveStockScreen1,
  retrieveStockScreen1Data,
  retrieveStockSession,
} from "../../Services/StockSessionApiService";
import { getExchangeRate } from "../../Services/ExchangeRateApiService";
import ChangeSign from "../../Components/PrimeReact/changeSign";
import { useAuthHeader, useSignOut } from "../../auth/AuthService";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import IndexSummaryDataDisplay from "../../Components/PrimeReact/MarketSummary/indexSummaryDataDisplay";

export default function Screen1P() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState({});
  const authHeader = useAuthHeader();

  var START = 1;
  var MARKET_CLOSING = 99;
  const [STATE, setSTATE] = useState(START);
  const [ROTATE, setROTATE] = useState(false);

  const [exchangeRate, setExchangeRate] = useState("");
  const [board, setBoard] = useState("M");
  const [currency, setCurrency] = useState("KHR");
  const [icode, setIcode] = useState("");
  const [nextLang, setNextLang] = useState();
  const [nextIcode, setNextIcode] = useState();
  const [countdownCheck, setCountdownCheck] = useState(false);

  const [closePrice, setClosePrice] = useState();
  const [highPrice, setHighPrice] = useState();
  const [lowPrice, setLowPrice] = useState();
  const [lastPrice, setLastPrice] = useState();

  const signOut = useSignOut();
  const navigator = useNavigate();

  const logoutFunction = () => {
    if (signOut()) {
      navigator("/login");
    }
  };

  async function update() {
    await retrieveStockScreen1Data(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        setData(data);
        setHighPrice(data?.chigh);
        setLowPrice(data?.clow);
        setLastPrice(data?.cprice ? data?.cprice : data?.bprice);
      })
      .catch((error) => {
        if (error.response.status === 403) {
          logoutFunction();
        }
      });

    check();
  }

  //CLOSING
  async function updateClosing() {
    await retrieveStockScreen1Data(board, icode, currency, authHeader())
      .then((response) => {
        let data = response.data.data;
        setClosePrice(data?.cprice);
        if (data?.ctquantity == 0 && data?.bprice == data?.cprice) {
          setHighPrice(data?.cprice);
          setLowPrice(data?.cprice);
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          logoutFunction();
        }
      });
    // setClosePrice(data?.cprice);
    // if (data?.ctquantity == 0 && data?.bprice == data?.cprice) {
    //     setHighPrice(data?.cprice);
    //     setLowPrice(data?.cprice);
    // }
    setSTATE(MARKET_CLOSING);
  }

  async function check() {
    await retrieveStockSession(authHeader())
      .then((response) => {
        response.data.data.session && updateClosing();
        // if (response.data.data.session) {
        //     updateClosing();
        // } else {
        //     setClosePrice(0)
        // }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          logoutFunction();
        }
      });
  }

  async function fetchExchangeRate() {
    const { data } = await getExchangeRate();
    data && setExchangeRate(data?.data[0]?.exchangeRate);
  }

  async function init() {
    let rotateTime;
    fetchExchangeRate();

    await retrieveStockScreen1(nextLang, nextIcode, authHeader())
      .then((response) => {
        let data = response.data.data;

        setNextIcode(data?.nexticode);
        setNextLang(data?.nextlanguage);
        setBoard(data?.issue?.mtype == 1 ? "M" : "G");
        setIcode(data?.icode);
        setCurrency(data?.currencyType);

        let lang = data.language == "cat" ? "kh" : "en";
        i18n.changeLanguage(lang);
        rotateTime = data.rotateTime;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          logoutFunction();
        }
      });

    return rotateTime;
  }

  function rotateNext() {
    setROTATE(!ROTATE);
  }

  function checkIPOCountdown() {
    if (data?.ipo && new Date().setHours(8, 59, 50) == new Date().getTime()) {
      startCountDown();
    }
  }

  useEffect(() => {
    icode && update();
    const intervalUpdateData = setInterval(update, 5000);

    if (
      STATE == MARKET_CLOSING ||
      new Date().setHours(15, 10, 0) < new Date().getTime()
    ) {
      clearInterval(intervalUpdateData);
    }

    return () => {
      clearInterval(intervalUpdateData);
    };
  }, [STATE, icode]);

  useEffect(() => {
    let rotateTime = async () => await init();
    var intervalRotate;

    rotateTime().then((e) => {
      e && (intervalRotate = setInterval(rotateNext, e * 1000));
    });

    return () => {
      clearInterval(intervalRotate);
    };
  }, [ROTATE]);

  useEffect(() => {
    checkIPOCountdown();
    const intervalCheckIpo = setInterval(checkIPOCountdown, 1000);

    return () => {
      clearInterval(intervalCheckIpo);
    };
  }, [data?.ipo]);

  var countDownSeconds = 9;
  var countDownTimer;
  function startCountDown() {
    setCountdownCheck(true);
    countDownTimer = setInterval(function () {
      var posLeft = 360;
      if (countDownSeconds == 9) posLeft = -120;
      $("#hideMsg span").animate(
        {
          opacity: 0.25,
          top: 410,
          left: posLeft,
          fontSize: "50rem",
        },
        950,
        function () {
          $("#hideMsg span").css("opacity", 1);
          $("#hideMsg span").css("font-size", "10em");
          $("#hideMsg span").text(countDownSeconds--);
          $("#hideMsg span").css({ left: "450px", top: "400px" });
        }
      );

      if (countDownSeconds == 0) {
        $("#hideMsg").fadeOut(1000);
        clearInterval(countDownTimer);
        setTimeout(() => setCountdownCheck(false), 1000);
      }
    }, 1000);
  }

  return (
    <div className="relative md:h-screen">
      <div className="h-1rem"></div>

      <div className="flex justify-content-center">
        <div className="flex w-12 justify-content-center">
          <div className="grid w-full">
            <div className="col-12 text-white">
              <div className="grid">
                <div className="col-4 h-6rem md:h-full">
                  <Logo />
                </div>
                <IndexSummaryDataDisplay STATE={1} />
                <div className="col-4 flex align-items-center">
                  <div className="grid w-full text-3xl">
                    <div className="col-12 flex justify-content-end">
                      <img
                        src={`/img/issuer_logo/${icode}_logo.PNG`}
                        className="h-7rem pr-2"
                      />
                    </div>
                    {/* <div className="col-12 flex justify-content-center">
                      <span className="text-white text-lg font-bold">
                        {i18n.language == "en" ? data?.inameEn : data?.inameKh}
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-content-center bg-screen shadow-1">
        <div className="flex w-12 justify-content-center pt-3 pb-8 px-3">
          <div className="grid w-full">
            <div className="col-12 flex justify-content-center">
              <span className="text-white text-5xl font-bold">
                {i18n.language == "en" ? data?.inameEn : data?.inameKh}
              </span>
            </div>
            <div
              className={
                (i18n.language == "kh" ? "-mt-6" : "-mt-3") + " col-12 "
              }
            >
              <div className="flex justify-content-between align-items-end pb-2">
                <span
                  className={
                    (i18n.language == "kh" ? "pb-0" : "") +
                    " flex md:text-3xl text-lg font-bold"
                  }
                >
                  {t("Snapshot")} {"("+currency+")"}
                </span>
                <span className="flex md:text-3xl text-lg font-bold">
                  <DateTimer type={1} /> / {t("Time")}:<DateTimer type={2} />
                </span>
              </div>
              <div className="flex m-0 grid w-full">
                <div className="col-12 md:col-7 p-0 md:pr-3">
                  <div className="card h-35rem p-4 shadow-1 border-round-lg bg-card">
                    <div
                      className={
                        (i18n.language == "kh"
                          ? "line-height-5"
                          : "line-height-3-5") + " grid"
                      }
                    >
                      <div className="col-6">
                        <div
                          className={
                            (i18n.language == "kh" ? "pb-2" : "pb-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Market")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.board == 1
                              ? t("Main Board")
                              : t("Growth Board")}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.ipo ? t("IPO Price") : t("Base Price")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.bprice
                              ? data?.bprice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Exp. Price")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.etprice
                              ? data?.etprice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Upper Limit")}
                          </span>
                          <span
                            className={
                              (data?.upprice && data?.upprice != data?.bprice
                                ? data?.upprice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-2xl text-sm font-bold"
                            }
                          >
                            {data?.upprice
                              ? data?.upprice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Open")}
                          </span>
                          <span
                            className={
                              (data?.oprice && data?.oprice != data?.bprice
                                ? data?.oprice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-2xl text-sm font-bold"
                            }
                          >
                            {data?.oprice
                              ? data?.oprice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("High")}
                          </span>
                          <span
                            className={
                              (highPrice && highPrice != data?.bprice
                                ? highPrice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-2xl text-sm font-bold"
                            }
                          >
                            {highPrice
                              ? highPrice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Volume")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.ctquantity
                              ? data?.ctquantity.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                      </div>
                      <div className="col-6">
                        {/* <div
                          className={
                            (i18n.language == "kh" ? "pb-3" : "pb-2") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-lg text-lg font-bold pb-2">
                            &nbsp;
                          </span>
                        </div> */}
                        <div
                          className={
                            (i18n.language == "kh" ? "pb-2" : "pb-3") +
                            " flex justify-content-between align-items-center px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            &nbsp;
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("P/E Ratio")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.pe
                              ? data?.pe.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Exp. Quantity")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.etquantity
                              ? data?.etquantity.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Lower Limit")}
                          </span>
                          <span
                            className={
                              (data?.lowprice && data?.lowprice != data?.bprice
                                ? data?.lowprice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-2xl text-sm font-bold"
                            }
                          >
                            {data?.lowprice
                              ? data?.lowprice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Close")}
                          </span>
                          <span
                            className={
                              (closePrice && closePrice != data?.bprice
                                ? closePrice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-2xl text-sm font-bold"
                            }
                          >
                            {closePrice
                              ? closePrice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Low")}
                          </span>
                          <span
                            className={
                              (lowPrice && lowPrice != data?.bprice
                                ? lowPrice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-2xl text-sm font-bold"
                            }
                          >
                            {lowPrice ? lowPrice.toLocaleString("en-US") : "-"}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "py-2" : "py-3") +
                            " flex justify-content-between px-2 border-bottom-1 border-blue-700"
                          }
                        >
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Value")}
                          </span>
                          <span className="md:text-2xl text-sm font-bold">
                            {data?.ctamount
                              ? data?.ctamount.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-5 p-0 md:pl-3 mt-4 md:mt-0">
                  <div className="card h-35rem p-4 shadow-1 border-round-lg bg-card">
                    <div className="grid">
                      <div className="col-12 py-0">
                        <div className="flex justify-content-between px-2">
                          <span className="md:text-2xl text-sm font-bold">
                            {t("Last")}
                          </span>
                          <span
                            className={
                              (data?.cpday == 0
                                ? "text-white"
                                : data?.cpday < 0
                                ? "text-red"
                                : "text-green") +
                              " md:text-3xl text-sm font-bold flex"
                            }
                          >
                            <ChangeSign
                              change={data?.cpday}
                              vol_qty={data?.ctquantity}
                              base_price={data?.bprice}
                              last_price={data?.cprice}
                              lower_price={data?.lowprice}
                              upper_price={data?.upprice}
                            ></ChangeSign>
                            {data?.cpday && Math.abs(data?.cpday)}
                          </span>
                        </div>
                        <div
                          className={
                            (i18n.language == "kh" ? "pb-0 -mt-3" : "pb-2") +
                            " flex justify-content-center"
                          }
                        >
                          <span
                            className={
                              (lastPrice && lastPrice != data?.bprice
                                ? lastPrice > data?.bprice
                                  ? "text-green"
                                  : "text-red"
                                : "text-white") +
                              " md:text-5xl text-lg font-bold"
                            }
                          >
                            {lastPrice
                              ? lastPrice.toLocaleString("en-US")
                              : "-"}
                          </span>
                        </div>
                        <div className="flex justify-content-around gap-7 py-3 px-2">
                          <div className="flex flex-column align-items-center border-blue-700 border-1 border-round-xl md:px-5 px-2 py-2 bg-card">
                            <span className="md:text-2xl text-sm font-bold">
                              {t("Best Ask")}
                            </span>
                            <span
                              className={
                                (data?.ask?.firstAskVal &&
                                data?.ask?.firstAskVal != data?.bprice
                                  ? data?.ask?.firstAskVal > data?.bprice
                                    ? "text-green"
                                    : "text-red"
                                  : "text-white") + " md:text-2xl font-bold"
                              }
                            >
                              {data?.ask?.firstAskVal
                                ? data?.ask?.firstAskVal.toLocaleString("en-US")
                                : "-"}
                            </span>
                          </div>
                          <div className="flex flex-column align-items-center border-blue-700 border-1 border-round-xl md:px-5 px-2 py-2 bg-card">
                            <span className="md:text-2xl text-sm font-bold">
                              {t("Best Bid")}
                            </span>
                            <span
                              className={
                                (data?.bid?.firstBidVal &&
                                data?.bid?.firstBidVal != data?.bprice
                                  ? data?.bid?.firstBidVal > data?.bprice
                                    ? "text-green"
                                    : "text-red"
                                  : "text-white") + " md:text-2xl font-bold"
                              }
                            >
                              {data?.bid?.firstBidVal
                                ? data?.bid?.firstBidVal.toLocaleString("en-US")
                                : "-"}
                            </span>
                          </div>
                        </div>
                        <div className="grid pt-2 line-height-3">
                          <div className="col-6 pb-0 pt-2 border-top-1 border-blue-700">
                            <div className="flex justify-content-between py-2">
                              <span className="md:text-2xl text-sm font-bold">
                                {t("Quantity")}
                              </span>
                              <span className="md:text-2xl text-sm font-bold">
                                {t("Ask")}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span className="md:text-2xl text-sm">
                                {data?.ask?.firstAskVol
                                  ? data?.ask?.firstAskVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span
                                className={
                                  (data?.ask?.firstAskVal &&
                                  data?.ask?.firstAskVal != data?.bprice
                                    ? data?.ask?.firstAskVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.ask?.firstAskVal
                                  ? data?.ask?.firstAskVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span className="md:text-2xl text-sm">
                                {data?.ask?.secondAskVol
                                  ? data?.ask?.secondAskVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span
                                className={
                                  (data?.ask?.secondAskVal &&
                                  data?.ask?.secondAskVal != data?.bprice
                                    ? data?.ask?.secondAskVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.ask?.secondAskVal
                                  ? data?.ask?.secondAskVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span className="md:text-2xl text-sm">
                                {data?.ask?.thirdAskVol
                                  ? data?.ask?.thirdAskVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span
                                className={
                                  (data?.ask?.thirdAskVal &&
                                  data?.ask?.thirdAskVal != data?.bprice
                                    ? data?.ask?.thirdAskVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.ask?.thirdAskVal
                                  ? data?.ask?.thirdAskVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span className="md:text-2xl text-sm">
                                {data?.ask?.fourthAskVol
                                  ? data?.ask?.fourthAskVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span
                                className={
                                  (data?.ask?.fourthAskVal &&
                                  data?.ask?.fourthAskVal != data?.bprice
                                    ? data?.ask?.fourthAskVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.ask?.fourthAskVal
                                  ? data?.ask?.fourthAskVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span className="md:text-2xl text-sm">
                                {data?.ask?.fifthAskVol
                                  ? data?.ask?.fifthAskVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span
                                className={
                                  (data?.ask?.fifthAskVal &&
                                  data?.ask?.fifthAskVal != data?.bprice
                                    ? data?.ask?.fifthAskVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.ask?.fifthAskVal
                                  ? data?.ask?.fifthAskVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                          </div>
                          <div className="col-6 border-left-1 border-top-1 border-blue-700 pb-0 pt-2">
                            <div className="flex justify-content-between py-2">
                              <span className="md:text-2xl text-sm font-bold">
                                {t("Bid")}
                              </span>
                              <span className="md:text-2xl text-sm font-bold">
                                {t("Quantity")}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span
                                className={
                                  (data?.bid?.firstBidVal &&
                                  data?.bid?.firstBidVal != data?.bprice
                                    ? data?.bid?.firstBidVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.bid?.firstBidVal
                                  ? data?.bid?.firstBidVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span className="md:text-2xl text-sm">
                                {data?.bid?.firstBidVol
                                  ? data?.bid?.firstBidVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span
                                className={
                                  (data?.bid?.secondBidVal &&
                                  data?.bid?.secondBidVal != data?.bprice
                                    ? data?.bid?.secondBidVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.bid?.secondBidVal
                                  ? data?.bid?.secondBidVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span className="md:text-2xl text-sm">
                                {data?.bid?.secondBidVol
                                  ? data?.bid?.secondBidVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span
                                className={
                                  (data?.bid?.thirdBidVal &&
                                  data?.bid?.thirdBidVal != data?.bprice
                                    ? data?.bid?.thirdBidVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.bid?.thirdBidVal
                                  ? data?.bid?.thirdBidVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span className="md:text-2xl text-sm">
                                {data?.bid?.thirdBidVol
                                  ? data?.bid?.thirdBidVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span
                                className={
                                  (data?.bid?.fourthBidVal &&
                                  data?.bid?.fourthBidVal != data?.bprice
                                    ? data?.bid?.fourthBidVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.bid?.fourthBidVal
                                  ? data?.bid?.fourthBidVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span className="md:text-2xl text-sm">
                                {data?.bid?.fourthBidVol
                                  ? data?.bid?.fourthBidVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                            <div className="flex py-1 justify-content-between">
                              <span
                                className={
                                  (data?.bid?.fifthBidVal &&
                                  data?.bid?.fifthBidVal != data?.bprice
                                    ? data?.bid?.fifthBidVal > data?.bprice
                                      ? "text-green"
                                      : "text-red"
                                    : "text-white") + " md:text-2xl text-sm"
                                }
                              >
                                {data?.bid?.fifthBidVal
                                  ? data?.bid?.fifthBidVal.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                              <span className="md:text-2xl text-sm">
                                {data?.bid?.fifthBidVol
                                  ? data?.bid?.fifthBidVol.toLocaleString(
                                      "en-US"
                                    )
                                  : "-"}
                              </span>
                            </div>
                          </div>
                          <div
                            className={
                              " col-12 flex justify-content-between align-items-center border-y-1 border-blue-700"
                            }
                          >
                            <span className="flex md:text-2xl text-sm font-bold">
                              {data?.ask?.totalAsk
                                ? data?.ask?.totalAsk.toLocaleString("en-US")
                                : "-"}
                            </span>
                            <span className="flex md:text-2xl text-sm font-bold">
                              {t("Total")}
                            </span>
                            <span className="flex md:text-2xl text-sm font-bold">
                              {data?.bid?.totalBid
                                ? data?.bid?.totalBid.toLocaleString("en-US")
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stock Scroller */}
      <div className="py-1 shadow-2 w-full absolute bottom-0 bg-card hidden-print">
        <div className="col-12 border-bottom-1 border-blue-700">
          <StockScroller STATE={1} EXCHANGERATE={exchangeRate} />
        </div>
        <div className={(i18n.language == "kh" ? "py-0" : "") + " col-12"}>
          <DisclosureScroller />
        </div>
      </div>
      <div
        id="hideMsg"
        className={
          (countdownCheck ? "block" : "hidden") + " count-down-wrapper"
        }
      >
        <div style={{ display: "table", width: "100%", height: "100%" }}>
          <span className="ve count-down">10</span>
        </div>
      </div>
    </div>
  );
}
